import { useSyncExternalStore } from 'react';
import * as Sentry from '@sentry/react';

const subscribe = (callback: EventListener) => {
  window.addEventListener('token-change', callback);
  return () => {
    window.removeEventListener('token-change', callback);
  };
};

const messageSubscribe = (callback: EventListener) => {
  window.addEventListener('token-change', callback);
  return () => {
    window.removeEventListener('token-change', callback);
  };
};

// Return the current value from the browser API
const getSnapshot = () => localStorage.getItem('token');

// Return the current value from the browser API
const getMessageSnapshot = () => localStorage.getItem('logout-message');

function getTenantFromHost(): string {
  return window.location.hostname.split('.')[0] || 'unknown';
}

const useToken = () => {
  const item = useSyncExternalStore(subscribe, getSnapshot);
  const message = useSyncExternalStore(messageSubscribe, getMessageSnapshot);

  const token = item;

  const setValue = (v: string | null, msg?: string) => {
    if (v === null) {
      localStorage.removeItem('token');
      Sentry.setUser(null);
      Sentry.setTag('tenant', undefined);
    } else {
      localStorage.setItem('token', v);
      Sentry.setUser({ id: v, role: 'kiosk' });
      Sentry.setTag('tenant', getTenantFromHost());
    }

    // The event name has to match the eventListeners defined in the subscribe function
    window.dispatchEvent(new StorageEvent('token-change'));
    if (msg) {
      localStorage.setItem('logout-message', JSON.stringify(msg));
      window.dispatchEvent(new StorageEvent('logout-message'));
    }
  };

  return { token, setToken: setValue, message };
};

export default useToken;
